<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :disabled="disabled"
    min-width="290px"
    transition="slide-y-transition"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        :value="humanDate"
        :clearable="clearable"
        :disabled="disabled"
        :hide-details="dense"
        :class="fieldClasses"
        :error-messages="errorMessages"
        :hint="hint"
        :persistent-hint="true"
        v-on="on"
        readonly
        @input="handleInput"
      ></v-text-field>
    </template>

    <v-date-picker
      :value="date"
      :type="type"
      :min="minDate"
      :max="maxDate"
      no-title
      color="primary"
      :locale="locale"
      :first-day-of-week="firstDayOfWeek"
      @input="handleInput"
    />
  </v-menu>
</template>

<script>
import DateTimeField from '@/mixins/fields/date-time-field';

import { formatDate } from '@/helpers/intl';

export default {
  props: {
    value: [String, Date],
    min: [String, Date],
    max: [String, Date],
    label: {
      type: String,
      required: true,
    },
    returnDate: {
      type: Boolean,
    },
    month: {
      type: Boolean,
    },
    endOfMonth: {
      type: Boolean,
    },
    hint: {
      type: String,
    },
  },
  data() {
    return {
      menu: false,
      date: null,
    };
  },
  watch: {
    value() {
      this.setDateValue();
    },
  },
  created() {
    this.setDateValue();
  },
  computed: {
    locale() {
      return this.$root.$i18n.locale;
    },
    firstDayOfWeek() {
      return this.locale === 'ru' ? 1 : 0;
    },
    type() {
      return this.month ? 'month' : 'date';
    },
    humanDate() {
      if (this.month) {
        return formatDate(this.value); // humanizeDateMonth(this.value);
      }

      return formatDate(this.value); // humanizeDate(this.value);
    },
    minDate() {
      if (!this.min) {
        return;
      }

      return this.min;
    },
    maxDate() {
      if (!this.max) {
        return;
      }

      return this.max;
    },
  },
  methods: {
    setDateValue() {
      if (!this.value) {
        this.date = null;

        return;
      }

      if (this.month) {
        this.date = this.value; // todo: formatDateMonth

        return;
      }

      this.date = this.value;
    },
    handleInput(value) {
      this.menu = false;
      this.date = value || null;

      if (!value) {
        this.$emit('input', null);

        return;
      }

      if (this.returnDate) {
        this.$emit('input', value);

        return;
      }

      this.$emit('input', value);
    },
  },
  mixins: [DateTimeField],
};
</script>
